/**
 * A simple utility function to covert a Date in UTC to the user's local time
 * @param timestampUtc the Date in UTC
 * @returns the date in the user's local time
 */
function convertDateTime(timestamp: Date | string): Date {
  // get the timestamp and subtract the local timezone adjustment from it. We store times in UTC strings in the
  // database and JS assumes they're local time when a new Date object is made from it.
  // setMinutes returns milliseconds since 1/1/1970 00:00, and updates the Date object in place
  const timestampUtc = new Date(timestamp)
  timestampUtc.setMinutes(timestampUtc.getMinutes() - timestampUtc.getTimezoneOffset());
  const timestampLocal = new Date(timestampUtc);

  return timestampLocal;
}

export { convertDateTime }